import { render, staticRenderFns } from "./CommonHint.vue?vue&type=template&id=b0185b72&scoped=true"
import script from "./CommonHint.vue?vue&type=script&lang=js"
export * from "./CommonHint.vue?vue&type=script&lang=js"
import style0 from "./CommonHint.vue?vue&type=style&index=0&id=b0185b72&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0185b72",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2326903440/src/bitbucket.org/Modis-ito/frontend-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b0185b72')) {
      api.createRecord('b0185b72', component.options)
    } else {
      api.reload('b0185b72', component.options)
    }
    module.hot.accept("./CommonHint.vue?vue&type=template&id=b0185b72&scoped=true", function () {
      api.rerender('b0185b72', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/drc/pages/submit-form/components/CommonHint.vue"
export default component.exports